var router = require('pjax').Router;
var index = require('./index.js');
var form = require('./form.js');

router.get('judging/copy-panel/:any', form);
router.get('judging/panel/:any', form);
router.get('judging/panel', index);
